export default __webpack_public_path__ + "static/media/undraw_online_articles_79ff.490a8c59.svg";